<div class="main-div">
    <div class="expander">
        <button mat-raised-button color="secondary" type="button" (click)="accordion.openAll()" class="btn-default">Expand All </button>
        <div class="divider"></div>
        <button mat-raised-button color="secondary" type="button"  (click)="accordion.closeAll()" class="btn-default">Collapse All </button>
    </div>
    <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Player Requests</mat-expansion-panel-header>
            <app-requests-table></app-requests-table>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Active Games</mat-expansion-panel-header>
            <app-active-player-table></app-active-player-table>
        </mat-expansion-panel>
    </mat-accordion>
</div>
